import { Row, Col, Container } from "react-bootstrap";
import React from "react";
import PropTypes from "prop-types";

const QuoteBlock = ({ data, classes }) => {
  return (
    <Container fluid className={classes + " hero-block"}>
      <Row>
        <Col
          data-aos={"fade-up"}
          xs={12}
          md={5}
          lg={5}
          className="col quote-col"
        >
          <div className="quote-container">
            <h2 className="top-header">{data.quote}</h2>
            <p>{data.name}</p>
            <p>{data.title}</p>
          </div>
        </Col>
        <Col
          data-aos={"fade-up"}
          xs={12}
          md={7}
          lg={7}
          className="col image-col"
        >
          <div className="image-container">
            <img
              className="image"
              src={`${process.env.REACT_APP_STRAPI_API_URL}${data.image?.data?.attributes?.url}`}
              alt={data.image.data.attributes.alternativeText}
            ></img>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
QuoteBlock.propTypes = {
  data: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.shape({
      data: PropTypes.shape({
        attributes: PropTypes.shape({
          url: PropTypes.string.isRequired,
          alternativeText: PropTypes.string.isRequired,
        }),
      }),
    }),
  }).isRequired,
  classes: PropTypes.string.isRequired,
};
export default QuoteBlock;
